import React from 'react'
import PropTypes from 'prop-types'

import { Feed, Icon, List } from 'semantic-ui-react'

import { getDurationInText, getFormattedDateTimeString } from 'Global/Helpers/timeHelpers'

import DebugFeedSuccess from './DebugFeedSuccess'

const DebugFeed = props => {
  const { events } = props

  const mappedUpdateEvents = events.map(item => {
    return (
      <Feed.Event key={item.id}>
        <Feed.Label>
          <Icon name="refresh" />
        </Feed.Label>

        <Feed.Content>
          <Feed.Summary>
            An update finished.
            <Feed.Date>{getFormattedDateTimeString(item.updatedAt)}</Feed.Date>
          </Feed.Summary>

          <DebugFeedSuccess success={item.success} />

          {item.error !== null ? <Feed.Extra text>{item.error}</Feed.Extra> : null}

          {item.success !== null ? (
            <Feed.Extra text>
              <List>
                <List.Item>
                  <List.Icon name="clock" />
                  <List.Content>{`${getDurationInText(item.length)}.`}</List.Content>
                </List.Item>

                <List.Item>
                  <List.Icon name="info circle" />
                  <List.Content>{`${item.rugs} rugs found.`}</List.Content>
                </List.Item>

                <List.Item>
                  <List.Icon name="check circle" />
                  <List.Content>{`${item.rugsUpdated} rugs updated.`}</List.Content>
                </List.Item>

                <List.Item>
                  <List.Icon name="remove circle" />
                  <List.Content>{`${item.rugsNotUpdated} rugs not updated.`}</List.Content>
                </List.Item>
              </List>
            </Feed.Extra>
          ) : null}
        </Feed.Content>
      </Feed.Event>
    )
  })

  return <Feed>{mappedUpdateEvents}</Feed>
}

DebugFeed.propTypes = {
  events: PropTypes.array.isRequired,
}

export default DebugFeed
